import Component from '../colorz/Component';

export default class WorldHQs extends Component {
	onInit(el) {
		this.el = el;
		this.continentEntries = this.el.querySelectorAll('[data-continent-entry]');
		this.continentBlocks = this.el.querySelectorAll('[data-continent-block]');
		this.backButtons = this.el.querySelectorAll('[data-back]');
		this.countryButtons = this.el.querySelectorAll('[data-country]');
		this.headquarterCountries = this.el.querySelectorAll(
			'[data-headquarter-country]',
		);
		this.images = this.el.querySelectorAll('[data-image]');
		this.defaultViewElements = this.el.querySelectorAll('[data-default-view]');

		// Find the default image (first image container, before the continent loop)
		this.defaultImageContainer = this.images[0] || null;

		this.init();
		this.addEventListeners();
	}

	init() {
		// Hide all continent blocks on load
		this.continentBlocks.forEach((block) => {
			block.classList.add('u-hidden');
		});

		// Hide all headquarter countries on load
		this.headquarterCountries.forEach((country) => {
			country.classList.add('u-hidden');
		});

		// Hide all continent images on load (keep only default image visible)
		this.images.forEach((image, index) => {
			// The first image is the default one, keep it visible
			if (index > 0) {
				image.classList.add('u-hidden');
			}
		});
	}

	addEventListeners() {
		// Handle continent entry clicks
		this.continentEntries.forEach((entry) => {
			entry.addEventListener('click', (e) => {
				this.handleContinentEntryClick(e);
			});
		});

		// Handle back button clicks using event delegation
		this.el.addEventListener('click', (e) => {
			const backButton = e.target.closest('[data-back]');
			if (backButton) {
				e.preventDefault();
				e.stopPropagation();
				this.handleBackClick(e);
			}
		});

		// Handle country clicks
		this.countryButtons.forEach((button) => {
			button.addEventListener('click', (e) => {
				this.handleCountryClick(e);
			});
		});
	}

	handleContinentEntryClick(e) {
		const continentId = e.currentTarget.getAttribute('data-continent-entry');
		const isMobile = window.innerWidth < 1080; // Desktop breakpoint

		// Remove is-selected class from all countries
		this.removeSelectedFromCountries();

		// Hide all data-default-view elements
		this.defaultViewElements.forEach((element) => {
			element.classList.add('u-hidden');
		});

		// Hide all continent blocks
		this.continentBlocks.forEach((block) => {
			block.classList.add('u-hidden');
		});

		// Hide all headquarter countries first
		this.headquarterCountries.forEach((country) => {
			country.classList.add('u-hidden');
		});

		if (isMobile) {
			// On mobile: show all headquarter countries for this continent directly
			const targetBlock = this.el.querySelector(
				`[data-continent-block="${continentId}"]`,
			);
			if (targetBlock) {
				// Show the continent block (for the back button)
				targetBlock.classList.remove('u-hidden');

				// Find the right column for this continent
				const rightColumn = targetBlock.nextElementSibling;
				if (rightColumn) {
					// Show all headquarter countries in this continent's right column
					const continentHeadquarters = rightColumn.querySelectorAll(
						'[data-headquarter-country]',
					);
					continentHeadquarters.forEach((headquarter) => {
						headquarter.classList.remove('u-hidden');
					});
				}
			}

			// Scroll to top of the page on mobile
			window.scrollTo({
				top: 0,
				behavior: 'smooth',
			});
		} else {
			// On desktop: show continent block with countries list
			const targetBlock = this.el.querySelector(
				`[data-continent-block="${continentId}"]`,
			);
			if (targetBlock) {
				targetBlock.classList.remove('u-hidden');
			}

			// Show the corresponding continent image and hide default image
			this.showContinentImage(continentId);
		}
	}

	handleBackClick(e) {
		// Remove is-selected class from all countries
		this.removeSelectedFromCountries();

		// Show all data-default-view elements
		this.defaultViewElements.forEach((element) => {
			element.classList.remove('u-hidden');
		});

		// Hide all continent blocks
		this.continentBlocks.forEach((block) => {
			block.classList.add('u-hidden');
		});

		// Show the default image and hide all continent images
		this.showDefaultImage();

		// Hide all headquarter countries
		this.headquarterCountries.forEach((country) => {
			country.classList.add('u-hidden');
		});
	}

	handleCountryClick(e) {
		const countryId = e.currentTarget.getAttribute('data-country');

		// Remove is-selected class from all countries
		this.removeSelectedFromCountries();

		// Add is-selected class to the clicked country
		e.currentTarget.classList.add('is-selected');

		// Hide all images (default and continent images)
		this.images.forEach((image) => {
			image.classList.add('u-hidden');
		});

		// Hide all headquarter countries
		this.headquarterCountries.forEach((country) => {
			country.classList.add('u-hidden');
		});

		// Show the corresponding headquarter country
		const targetHeadquarter = this.el.querySelector(
			`[data-headquarter-country="${countryId}"]`,
		);
		if (targetHeadquarter) {
			targetHeadquarter.classList.remove('u-hidden');
		}
	}

	showContinentImage(continentId) {
		// Find the continent block
		const continentBlock = this.el.querySelector(
			`[data-continent-block="${continentId}"]`,
		);
		if (continentBlock) {
			// The image container is the next sibling div after the continent block
			const imageContainerDiv = continentBlock.nextElementSibling;
			if (imageContainerDiv) {
				const continentImage = imageContainerDiv.querySelector('.u-aspect-1-1');
				if (continentImage) {
					// Hide all images first
					this.images.forEach((img) => {
						img.classList.add('u-hidden');
					});
					// Show the continent image
					continentImage.classList.remove('u-hidden');
				}
			}
		}
	}

	showDefaultImage() {
		// Hide all images first
		this.images.forEach((img) => {
			img.classList.add('u-hidden');
		});

		// Show the default image (first image)
		if (this.defaultImageContainer) {
			this.defaultImageContainer.classList.remove('u-hidden');
		} else if (this.images.length > 0) {
			// Fallback: show first image if defaultImageContainer not found
			this.images[0].classList.remove('u-hidden');
		}
	}

	removeSelectedFromCountries() {
		// Remove is-selected class from all country buttons
		this.countryButtons.forEach((button) => {
			button.classList.remove('is-selected');
		});
	}
}
